import { createSlice } from '@reduxjs/toolkit'
import { getAuthTokens, getAuthState, saveAuthTokens, saveAuthState } from '../../Utilities/storageHelpers';

interface AuthState {
  isLoggedIn: boolean;
  accessToken?: string;
  refreshToken?: string;
}

const persistedTokens = getAuthTokens();
const persistedAuthState = getAuthState();

const initialState: AuthState = {
  isLoggedIn: persistedAuthState?.isLoggedIn || false,
  accessToken: persistedTokens?.accessToken,
  refreshToken: persistedTokens?.refreshToken,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state) => {
      state.isLoggedIn = true;
      saveAuthState({ isLoggedIn: true });
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.accessToken = undefined;
      state.refreshToken = undefined;
    },
    setTokens: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      saveAuthTokens({
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken
      });
    },
    restoreAuthFromStorage: (state) => {
      const tokens = getAuthTokens();
      const authState = getAuthState();
      if (tokens && authState) {
        state.accessToken = tokens.accessToken;
        state.refreshToken = tokens.refreshToken;
        state.isLoggedIn = authState.isLoggedIn;
      }
    },

  },
})

export const { loginSuccess, logout, setTokens, restoreAuthFromStorage } = authSlice.actions

export default authSlice.reducer